
/**
 * 区分数字门户/新门户
 * productVersion >= 20240101 数字门户
 * 
 * **/
import { getTenantInfo } from 'newapis/public'
import { listTenantByTenantIdAndUserCode } from 'newapis/permission'
// import { getLocalEnv } from '@/utils/tools';

import './utils/ce-track-sensors' // 引入神策埋点相关模块

const isInStandaloneMode = () =>
  (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');

if (isInStandaloneMode()) {
  // alert(localStorage.getItem('TOKEN'))
}

const portalVersion = 20240101
// 数字门户需要首次存储状态
import store from '@/store'
import { bootstrap, getUserInfoBy300 } from './numberPortal/basic/index';

window.addEventListener('load', () => {
  getTenantInfo().then(async res => {
    const { status, data } = res
    store.dispatch('user/setSearchEngines', data.tenantJson)
    if (status == 200 && data.tenantJson?.productVersion && Number(data.tenantJson.productVersion) >= portalVersion) {
      if(location.pathname==='/'||location.pathname==='/npmanager'||location.pathname==='/npmanager/home'){
        window.init2024Skeleton()
      }
      document.title = '数字门户'
      await bootstrap();
      await import('./numberPortal.entry');
      await store.dispatch('numberPortal/setTenantJson', data.tenantJson)
      await store.dispatch('user/setTenantJson', data.tenantJson)
      listTenantByTenantIdAndUserCode({ 
        userCode: store.state.numberPortal.userInfo.memberCode, 
        isSuper: store.state.user.userdata.isSuper
      }).then(res => {
        store.dispatch('numberPortal/setSiteList', res.data)
      });
      //获取登录用户昵称和二级账号
      getUserInfoBy300();
    } else {
      if(location.pathname==='/'||location.pathname==='/npmanager'||location.pathname==='/npmanager/home'){
        window.initSkeleton()
      }
      document.title = '新门户'
      await store.dispatch('user/setTenantJson', data.tenantJson)
      await import('./appCenter.entry');
    }

    if(status == 200 && data.tenantJson?.bossProductInstance) {
      //动态json
      // let env = getLocalEnv();
      let baseUrl = ''
      if(import.meta.env.VITE_ENV_CONFIG.includes('dev')) {
        baseUrl = `https://test-${data.tenantJson.bossProductInstance.toLowerCase()}.fastindexs.com`
      }
      // if(env == 'pre') {
      //   productions = 'pre-'
      // }
      let linkUrl = `${baseUrl}/npmanager/static_pwa/manifest.json?instance=${data.tenantJson.bossProductInstance.toUpperCase()}`
      // let linkUrl = window.location.origin + `/npmanager/static_pwa/manifest.json?instance=${data.tenantJson.bossProductInstance.toUpperCase()}`
      console.log(linkUrl);
      let links = document.createElement('link');
      links.rel = 'manifest'
      links.href = linkUrl;
      console.log(links, document.head, 'linksssss');
      document.head.append(links);
      //动态json 结束
    }
  })
});

window.addEventListener('beforeinstallprompt', function(e) {
  // beforeinstallprompt Event fired
  // e.prompt();
  // e.userChoice will return a Promise.
  e.userChoice.then(function(choiceResult) {
    //   alert(choiceResult.outcome);
    let eventValue = (choiceResult.outcome === 'dismissed') ? 0 : 1 /* 0取消，1安装 */
    //ga热门事件统计代码
    console.log(eventValue, '是否安装？1 表示已安装，0 表示未安装');
  });
});